<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Mark VSA as signed</h3>
    <p class="modal-subtitle mb-0">
      Choose why the Vendor Service Agreement requirement is being bypassed.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group mb-0">
      <label class="form-label" for="vsa-bypass-reason">Reason</label>
      <select
        id="vsa-bypass-reason"
        class="form-select"
        formControlName="reason"
      >
        <option [ngValue]="null" disabled>Select a reason</option>
        @for (option of bypassReasonOptions; track option.value) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>

    @if (isClientWaiverSelected) {
      <div class="alert alert-info mt-3 mb-0" role="status">
        Upload the client waiver in
        <strong>Documents &amp; notes → Signed documents</strong>
        before confirming. For US clients, upload Vendor Agreement and W9
        together (PDF). The uploaded document becomes the historical record.
      </div>
    }

    @if (selectedReason === 'DOCUSIGN_WEBHOOK_ISSUE') {
      <div class="alert alert-secondary mt-3 mb-0" role="status">
        Use this when the vendor signed in DocuSign but the webhook did not
        update VIVE. No document upload is required.
      </div>
    }
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline" (click)="close()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="form.invalid"
    (click)="confirm()"
  >
    Mark as signed
  </button>
</div>
